import React, { useState, useEffect } from "react";
import {
	Col,
	Row,
	Card,
	CardBody,
	Modal,
	ModalBody,
	ModalHeader,
	List,
	CardText,
	Spinner,
} from "reactstrap";
import "./styles.scss";
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Website/AuthService";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { authenticate } from "store/Auth/actions";
import { useTranslation } from "react-i18next";

const CallModal = ({ modal, setModal, phone }) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);

	return (
		<Modal
			isOpen={modal}
			toggle={() => setModal(false)}
			style={{ maxWidth: "700px", marginTop: "10%", width: "96%" }}
			className={`${
				AuthData.lang !== "ar" ? "websitPages" : "ar-wrapper websitPages"
			} br-25`}>
			<ModalBody className="m-0 p-0 fw-bold">
				<div className="overflow-hidden m-0 p-0">
					<h4 className="m-4 bask-font fw-bold text-center fs-1 text-primary">
						{t("Available contact Number for this unit")}
					</h4>
					<p className="mt-5 fw-bold font-size-24 text-color text-center">
						{phone}
					</p>
				</div>
			</ModalBody>
		</Modal>
	);
};
export default CallModal;
